import { localStorageService } from '../../services/localStorageService/localStorageService';
import { notificationSettingsService } from '../../services/notificationSettings/NotificationSettingsService';

/**
 * Persist the chosen app locale to the backend so Telegram notifications follow
 * the app language. Guarded by auth because the language switcher is also shown
 * on public auth screens — and best-effort, so a failed sync never blocks the
 * UI language change.
 */
export const syncNotificationLanguage = (locale: string): void => {
  if (!localStorageService().getAccessToken()) return;
  void notificationSettingsService.setLanguage(locale).catch(() => undefined);
};
